import React from 'react'
import { StyleSheet, View } from 'react-native'
import Barcode from 'react-barcode'
import { Text } from '@ui-kitten/components'
import { format } from 'date-fns'

import { withTranslation } from 'react-i18next'
class ProductSticker extends React.PureComponent {
  
  constructor(props) {
    super(props)
  }

  render() {
    const { t } = this.props
    return (
      <View style={[styles.container, { height: this.props.height, marginVertical: this.props.marginVertical }]}>
        <Text style={[styles.name, {fontSize: this.props.generalFontSize, lineHeight: this.props.generalFontSize}]}>
          {this.props.name}
        </Text>
        <Barcode value={this.props.barcode} lineColor='black' displayValue={true} fontSize={this.props.generalFontSize} flat={false} width={1.5} height={30} margin={5} format={this.props.barcodeFormat} />
        <View style={styles.rowContainer}>
          {this.props.weight && (<Text style={[styles.price, {fontSize: this.props.generalFontSize, lineHeight: this.props.generalFontSize}]}>
            {t('weight') + ': '}
            <Text style={[styles.priceNumber, {fontSize: this.props.priceFontSize, lineHeight: this.props.priceFontSize}]}>{this.props.weight + ' '}</Text>
          </Text>)}
          {this.props.price && (<Text style={[styles.price, {fontSize: this.props.generalFontSize, lineHeight: this.props.generalFontSize}]}>
            {t('price') + ': '}
            <Text style={[styles.priceNumber, {fontSize: this.props.priceFontSize, lineHeight: this.props.priceFontSize}]}>{this.props.price}</Text>
          </Text>)}
        </View>
        {/* Multiple Prices */}
        {this.props.additionalPrices && this.props.additionalPrices.length > 0 && (
          <View style={styles.rowContainer}>
            {this.props.additionalPrices.map((priceInfo, index) => (
              <Text key={index} style={[styles.price, {fontSize: this.props.generalFontSize, lineHeight: this.props.generalFontSize}]}>
                {priceInfo.name}: <Text style={styles.priceNumber}>{priceInfo.price}</Text>
              </Text>
            ))}
          </View>
        )}
        {this.props.date ? (<Text style={[styles.date, {fontSize: this.props.generalFontSize, lineHeight: this.props.generalFontSize}]}>
          {format(this.props.date, "d/M/y EEEE")}
        </Text>) : (
          <Text style={styles.date}></Text>
        )}
      </View>
    )
  }
}

export default withTranslation()(ProductSticker)

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    width: 220, // 220
    alignItems: 'center',
    justifyContent: 'center'
  },
  name: {
    textAlign: 'center',
    // height: 20,
    // fontSize: 8,
    // lineHeight: 10,
    flexWrap: 'wrap',
    color: '#000',
  },
  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  price: {
    // height: 20,
    // lineHeight: 12,
    color: '#000',
  },
  priceNumber: {
    fontWeight: 'bold',
    // fontSize: 12,
    // lineHeight: 12,
    color: '#000',
  },
  date: {
    // height: 20,
    // fontSize: 8,
    // lineHeight: 10,
    color: '#000',
  }
})
